import { useReducer } from 'react'
import { AnyAction } from 'redux'
import { history, useTypedSelector } from '../../redux/store'
import { setModuleDataAction } from '../../modules/pagecache'
import { useDispatch } from 'react-redux'
import { message, Form } from 'antd'
import { useLocation } from 'react-router-dom'
import { delTabsAction } from '../../modules/authtoken'
import { ADD_SUPPLIERUSER } from '../../api/System_Api'
import { getSupplierId, isResponseCodeSuccess } from '../../tools/util'
import { normalizeSupplierAccountMobile } from '../../tools/supplierAccount'

// action 类型定义
const ACCOUNTADD_ACTION_TYPE = {
  LOADING: 'ACCOUNT/LOADING',
}

// 当前状态接口
interface AccountAddState {
  loading: boolean
}
// 默认数据
const defaultState: AccountAddState = {
  loading: false,
}
const { LOADING } = ACCOUNTADD_ACTION_TYPE
// 默认 Reducer
const reducer = (state = defaultState, action: AnyAction) => {
  const arr = { ...state }
  switch (action.type) {
    case LOADING:
      arr.loading = action.value
      return arr
    default:
      return state
  }
}

const useAllocationEditHook = () => {
  const [state] = useReducer(reducer, defaultState)
  const { loading } = state
  const { tabsData } = useTypedSelector((state) => state.authtoken)
  const dispatchRedux = useDispatch()
  const location = useLocation()
  const { pathname } = location
  const [form] = Form.useForm()

  // 缓存数据
  const onCache = () => {
    // 缓存存数据
    const pathName = history.location.pathname
    const formData = form.getFieldsValue()
    const action = setModuleDataAction({
      key: pathName,
      data: {
        pageState: state, // 当前状态
        formData: formData,
      },
    })
    dispatchRedux(action)
  }

  // 表单变化
  const onFieldsChange = () => {
    onCache()
  }

  // 关闭
  const onClickClose = () => {
    let newurl = ''
    if (tabsData.length === 0) {
      // 最后一个tabs
      newurl = '/srm/home'
    }
    let delkey = ''
    if (tabsData.length > 0) {
      let param = 0
      tabsData.map((item, index) => {
        if (item.url === pathname) {
          delkey = item.key
          param = index - 1
        }
        return item
      })
      // 排除下标为1的
      const url = param >= 0 ? tabsData[param].url : '/srm/home'
      newurl = url
    }
    // 删除标签 跳转前一个标签页
    const pathName = history.location.pathname
    const action = setModuleDataAction({
      key: pathName,
      data: {
        pageState: state, // 当前状态
        formData: {
          roleName: undefined,
          empName: undefined,
          erpCode: undefined,
          mobile: undefined,
          empId: undefined,
          isSubProductMan: undefined,
          isProductAssess: undefined,
          assessProcedure: undefined,
          approveId: undefined,
          level: undefined,
        },
      },
    })
    dispatchRedux(action)
    dispatchRedux(delTabsAction(delkey))
    history.replace(newurl)
  }

  // 提交数据
  const onClickSave = async () => {
    const data = await form.validateFields()
    const res = await ADD_SUPPLIERUSER({
      mail: data.mail,
      mobile: normalizeSupplierAccountMobile(data.mobile),
      realName: data.realName.trim(),
      supplierId: getSupplierId(),
    })
    if (isResponseCodeSuccess(res.code)) {
      message.success('新增成功')
      setTimeout(() => {
        onClickClose()
      }, 500)
      form.resetFields()
    } else {
      message.warning(`${res.msg}`)
    }
  }

  return {
    form,
    loading,
    onFieldsChange,
    onClickSave,
    onClickClose,
  }
}

export default useAllocationEditHook
import { useReducer } from 'react'
import { AnyAction } from 'redux'
import { history, useTypedSelector } from '../../redux/store'
import { setModuleDataAction } from '../../modules/pagecache'
import { useDispatch } from 'react-redux'
import { message, Form } from 'antd'
import { useLocation } from 'react-router-dom'
import { delTabsAction } from '../../modules/authtoken'
import { ADD_SUPPLIERUSER } from '../../api/System_Api'
import { getSupplierId, isResponseCodeSuccess } from '../../tools/util'
import { normalizeSupplierAccountMobile } from '../../tools/supplierAccount'

// action 类型定义
const ACCOUNTADD_ACTION_TYPE = {
  LOADING: 'ACCOUNT/LOADING',
}

// 当前状态接口
interface AccountAddState {
  loading: boolean
}
// 默认数据
const defaultState: AccountAddState = {
  loading: false,
}
const { LOADING } = ACCOUNTADD_ACTION_TYPE
// 默认 Reducer
const reducer = (state = defaultState, action: AnyAction) => {
  const arr = { ...state }
  switch (action.type) {
    case LOADING:
      arr.loading = action.value
      return arr
    default:
      return state
  }
}

const useAllocationEditHook = () => {
  const [state] = useReducer(reducer, defaultState)
  const { loading } = state
  const { tabsData } = useTypedSelector((state) => state.authtoken)
  const dispatchRedux = useDispatch()
  const location = useLocation()
  const { pathname } = location
  const [form] = Form.useForm()

  // 缓存数据
  const onCache = () => {
    // 缓存存数据
    const pathName = history.location.pathname
    const formData = form.getFieldsValue()
    const action = setModuleDataAction({
      key: pathName,
      data: {
        pageState: state, // 当前状态
        formData: formData,
      },
    })
    dispatchRedux(action)
  }

  // 表单变化
  const onFieldsChange = () => {
    onCache()
  }

  // 关闭
  const onClickClose = () => {
    let newurl = ''
    if (tabsData.length === 0) {
      // 最后一个tabs
      newurl = '/srm/home'
    }
    let delkey = ''
    if (tabsData.length > 0) {
      let param = 0
      tabsData.map((item, index) => {
        if (item.url === pathname) {
          delkey = item.key
          param = index - 1
        }
        return item
      })
      // 排除下标为1的
      const url = param >= 0 ? tabsData[param].url : '/srm/home'
      newurl = url
    }
    // 删除标签 跳转前一个标签页
    const pathName = history.location.pathname
    const action = setModuleDataAction({
      key: pathName,
      data: {
        pageState: state, // 当前状态
        formData: {
          roleName: undefined,
          empName: undefined,
          erpCode: undefined,
          mobile: undefined,
          empId: undefined,
          isSubProductMan: undefined,
          isProductAssess: undefined,
          assessProcedure: undefined,
          approveId: undefined,
          level: undefined,
        },
      },
    })
    dispatchRedux(action)
    dispatchRedux(delTabsAction(delkey))
    history.replace(newurl)
  }

  // 提交数据
  const onClickSave = async () => {
    const data = await form.validateFields()
    const res = await ADD_SUPPLIERUSER({
      mail: data.mail,
      mobile: normalizeSupplierAccountMobile(data.mobile),
      realName: data.realName.trim(),
      supplierId: getSupplierId(),
    })
    if (isResponseCodeSuccess(res.code)) {
      message.success('新增成功')
      setTimeout(() => {
        onClickClose()
      }, 500)
      form.resetFields()
    } else {
      message.warning(`${res.msg}`)
    }
  }

  return {
    form,
    loading,
    onFieldsChange,
    onClickSave,
    onClickClose,
  }
}

export default useAllocationEditHook
